export default __webpack_public_path__ + "static/community_druid-b696e21d29f6d42cba6f92b919af7c28.png";